import { render, staticRenderFns } from "./gift-form-home.vue?vue&type=template&id=0d58205c&scoped=true&"
import script from "./gift-form-home.vue?vue&type=script&lang=js&"
export * from "./gift-form-home.vue?vue&type=script&lang=js&"
import style0 from "./gift-form-home.vue?vue&type=style&index=0&id=0d58205c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d58205c",
  null
  
)

export default component.exports